module.exports = __webpack_public_path__ + "static/media/googleplay.e620b8c7.svg";